import { useLocation, useNavigate, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { format } from 'date-fns';
import { id } from 'date-fns/locale';

import { menuItems } from 'lib/DefaultData';
import { signOutRequest } from 'store/actions/authActions';
import { useProfileUser } from '../ProfileLayout';

const CardMenuProfile = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const data = useProfileUser();

  const logout = () => {
    dispatch(signOutRequest());
    navigate('/login');
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';

    try {
      const cleanedDate = dateString.replace(' UTC', '').replace(' ', 'T').replace(/\s/g, '');

      const dateObj = new Date(cleanedDate);

      if (isNaN(dateObj.getTime())) {
        return 'Format Tanggal Salah';
      }

      return format(dateObj, 'dd MMMM yyyy', { locale: id });
    } catch (e) {
      console.error('Error formatting date:', e);
      return 'Invalid Date';
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm">
      {/* Profile Header */}
      <div className="flex flex-col items-center gap-1">
        <div className="bg-gray-100 rounded-full p-1 flex justify-center items-center overflow-hidden w-[120px] h-[120px]">
          <img
            alt="profile"
            src={data?.profile_picture || '/kin/assest/image/icon-profile.png'}
            className="h-full w-full object-cover"
            onError={(e) => {
              e.target.src = '/kin/assest/image/icon-profile.png';
            }}
          />
        </div>

        <div className="flex flex-col items-center mt-3">
          <span className="text-primary-main text-xl font-bold">{data?.name || 'User'}</span>
          <span className=" text-kin-text text-base font-regular">
            Joined Since {formatDate(data?.join_date)}
          </span>
        </div>
      </div>

      <hr className="my-6 border-gray-100" />

      {/* Navigation Menu */}
      <nav className="flex flex-col gap-1">
        {menuItems.map((menuItem) => {
          if (menuItem.name === 'Log Out') {
            return (
              <button
                key="logout-btn"
                onClick={logout}
                className="w-full text-left text-base rounded-xl py-3 px-4 font-bold text-red-500 hover:bg-red-50 transition-colors">
                {menuItem.name}
              </button>
            );
          }
          const isActive = location.pathname === menuItem.url;

          return (
            <Link
              key={menuItem.url}
              to={menuItem.url}
              className={`w-full text-base rounded-xl py-3 px-4 flex font-bold transition-all ${
                isActive ? 'bg-primary-main text-white' : 'text-kin-text hover:bg-gray-100'
              }`}>
              {menuItem.name}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default CardMenuProfile;
